import gql from "graphql-tag";

const getIntitution = gql`
  query Query($institutionId: ID!) {
    institution(id: $institutionId) {
      id
      name
      acronym
      code
      description
      isActive
      templates {
        id
        name
        description
        template_id
        category
        params
        attachments
      }
      settings {
        id
        name
        value
        createdAt
        updatedAt
        deletedAt
      }
    }
  }
`;

const getTemplates = gql`
  query Query($args: FilterParamsInput) {
    templates(args: $args) {
      id
      name
      description
      template_id
      category
      params
      attachments
    }
  }
`;

export { getIntitution, getTemplates }